<div id="bindingTimeContainer">
  @if (successMsg) {
    <div class="alert alert-success alert-trim" role="alert">
      {{ successMsg | translate }}
    </div>
  }

  @if (errorMsg) {
    <div class="alert alert-danger alert-trim" role="alert">
      {{ errorMsg | translate }}
    </div>
  }

  <p>{{ "BINDING_TIME" | translate }}</p>
  <form class="d-flex pt-2" name="bindingTimeForm">
    <button
      id="submitBindingTimeBtn"
      type="submit"
      [ngClass]="deviceBindingTimeControl.valid ? 'validBg' : 'invalidBg cursorDisabled'"
      [disabled]="deviceBindingTimeControl.invalid"
      (click)="submit()"
      >

      @if (!updating) {
        <span
          [ngClass]="deviceBindingTimeControl.valid ? 'fa-duotone fa-check' : 'fa-solid fa-x'"
          class="fa-lg"
          style="color: #FCFCFC"
        ></span>
      }

      @if (updating) {
        <span
          class="spinner-border spinner-border-sm"
          style="color: #FCFCFC"
        ></span>
      }
    </button>

    <input
      type="number"
      id="timeInput"
      name="timeInput"
      class="form-control"
      [formControl]="deviceBindingTimeControl"
      >

      <select
        class="form-control"
        id="timeFormatSelect"
        name="timeFormat"
        [formControl]="deviceBindingTimeUnitControl"
        >
        <option value="Days">{{ "DAYS" | translate }}</option>
        <option value="Months">{{ "MONTHS" | translate }}</option>
        <option value="Years">{{ "YEARS" | translate }}</option>
      </select>

      <select
        class="form-control"
        id="visibilitySelect"
        name="bindingTimeVisible"
        [formControl]="deviceBindingTimeVisibleControl"
        >
        <option [value]="false">{{ "DISABLED" | translate }}</option>
        <option [value]="true">{{ "ENABLED" | translate }}</option>
      </select>
    </form>

    @if (deviceBindingTimeControl.invalid) {
      <small class="text-danger invalidTimeText">
        {{ "INVALID_VALUE" | translate}}
      </small>
    }
    <form class="form mr-5 mt-4" >
      <div class="form-group pb-2">
        <label for="logoutUrl"><b>{{ "LOGOUT_URL" | translate }}</b></label>
        <div class="input-container">
          <textarea
            #logoutTextarea
            id="logoutUrl"
            name="logoutUrl"
            rows="1"
            class="form-control form-control-sm auto-grow"
            [formControl]="logoutUrlControl"
            placeholder="https://logout.url"
            (input)="autoGrow()"
            >
          </textarea>
          <i
            class="fa fa-copy copy-inside"
            title="Copy to clipboard"
            (click)="copyLogoutUrl()"
          ></i>
        </div>
        <button
          [disabled]="logoutUrlControl.invalid"
          type="button"
          class="btn btn-primary btn-sm mt-2"
          (click)="saveLogoutUrl()"
          >
          <span class="fa-light fa-floppy-disk"></span>
          {{ "SAVE" | translate }}
        </button>
      </div>
    </form>